import qs from 'query-string';

import getEnvConfig from 'utils/config/env';

import { AnalyticsFiltersProps } from '../service/filters.interface';

export const downloadAnalytics = async (
    filters: AnalyticsFiltersProps,
    type: 'csv' | 'xlsx'
) => {
    const token = localStorage.getItem('accessToken');
    const baseURL = new URL(getEnvConfig().env.API_URL + `/statistic`);
    let url = '';
    const query = qs.stringify(
        {
            export_type: type,
            period: filters.period,
            date_from: filters.date_from,
            date_to: filters.date_to,
            community_ids: filters.chat ? [filters.chat] : undefined,
        },
        { skipNull: true, arrayFormat: 'bracket-separator' }
    );

    switch (filters.viewAnalitycsType) {
        case 'all': {
            url = `${baseURL}/export-all-data?${query}`;
            break;
        }
        case 'members': {
            url = `${baseURL}/members/export?${query}`;
            break;
        }
        case 'finance': {
            url = `${baseURL}/export-payments?${query}`;
            break;
        }
        case 'messages': {
            url = `${baseURL}/messages/export?${query}`;
            break;
        }
        case 'moderation': {
            url = `${baseURL}/moderation/export?${query}`;
            break;
        }
        default: {
            throw new Error('Not implemented');
        }
    }

    const data = await fetch(url, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    const response = await data.json();
    window.open(
        `${getEnvConfig().env.API_URL.replace(/api\/v3/, '')}/${
            response.file_path || response.data.file_path
        }`
    );
};
